var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.492,
    height: 25.492,
    viewBox: "0 0 25.492 25.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    width: 25.492,
    height: 25.492,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(3.814 3.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M11.932,3a8.932,8.932,0,1,0,8.932,8.932A8.935,8.935,0,0,0,11.932,3Zm.6,13.1H11.336V14.909h1.191Zm0-2.977H11.336V7.764h1.191Z",
    transform: "translate(-3 -3)",
    fill: "#b22722"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.524cb93b645dbb98f85a070fb39d87b8.svg";
export { ForwardRef as ReactComponent };